<template>
  <div class="user-set main-panel large">
    <h1 class="panel-title">官方产样列表</h1>
    <div class="top">
      <div class="form">
        <div class="row">
          <div class="item col-1" :style="{ marginRight: '24px' }">
            <span class="label">时间</span>
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="mini"
              value-format="YYYY-MM-DD"
            />
          </div>
          <div class="item col-1">
            <div class="label">产品编号</div>
            <label
              ><input type="text" class="cg-input" v-model="username"
            /></label>
          </div>
          <div class="item col-1">
            <div class="label">分类</div>
            <el-select
              v-model="fl"
              placeholder="请选择分类"
              style="width: 100%"
              clearable
            >
              <el-option
                v-for="item in fenlei"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="item col-1">
            <div class="form-options">
              <el-button class="publish-btn" size="small" @click="search"
                >查询</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-table
      :data="list"
      border
      height="500px"
      style="width: 100%"
      class="custom-table"
    >
      <el-table-column align="center" prop="outerKey" label="产品编号" />
      <el-table-column align="center" prop="width" label="幅宽" />
      <el-table-column align="center" prop="weight" label="克重" />
      <el-table-column align="center" prop="ingredients" label="成分" />
      <el-table-column
        align="center"
        show-overflow-tooltip
        prop="categoryName"
        label="类别"
      >
        <template #default="scope">
          {{ catext(scope.row.categoryList) }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="title"
        show-overflow-tooltip
        label="标题"
      />
      <el-table-column
        align="center"
        prop="content"
        show-overflow-tooltip
        label="正文"
      />
      <el-table-column align="center" label="操作">
        <template #default="scope">
          <div class="options">
            <i
              class="update-icon el-icon-edit"
              title="修改"
              @click="up(scope.row)"
            ></i>
            <el-popconfirm
              title="确认删除吗?"
              confirmButtonText="确认"
              cancelButtonText="取消"
              @confirm="delUser(scope.row.id)"
            >
              <template #reference>
                <i class="del-icon el-icon-close" title="删除"></i>
              </template>
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
      <!-- 加载更多插槽，统一样式逻辑 -->
      <template #append>
        <div
          class="load-more"
          :class="{ 'no-more': noMore }"
          v-if="list.length"
          @click="loadMore"
        >
          {{ noMore ? "没有数据了~" : "点击加载下一页" }}
        </div>
      </template>
    </el-table>
    <el-dialog
      title="修改"
      center
      width="1200px"
      height="1200px"
      v-model="showUpdate"
      @close="handleDialogClose"
    >
      <my-dialog
        :row="editRow"
        @update-success="handleUpdateSuccess"
        @cancel="showUpdate = false"
      />
    </el-dialog>
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
import { ref, nextTick, onMounted, getCurrentInstance, watch } from "vue";
const { proxy } = getCurrentInstance();

import MyDialog from "./updata/user-product-launch.vue";

// 响应式变量
const showUpdate = ref(false);
const list = ref([]);
const dateRange = ref([]);
const username = ref("");
const fl = ref("");
const fenlei = ref([]);
const editRow = ref(null);

// 分页变量（统一配置）
const pages = ref({ page: 1, size: 50 });
const noMore = ref(false);
const loading = ref(false);

// 缓存值
const STORAGE_KEY = "product-list";

// 监听查询条件
watch([dateRange, username, fl], () => {
  const searchParams = {
    dateRange: dateRange.value,
    username: username.value,
    fl: fl.value,
  };
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(searchParams));
});

// 读取缓存回填表单
const loadSearchCache = () => {
  const cacheStr = sessionStorage.getItem(STORAGE_KEY);
  if (cacheStr) {
    try {
      const cache = JSON.parse(cacheStr);
      dateRange.value = cache.dateRange ?? [];
      username.value = cache.username ?? "";
      fl.value = cache.fl ?? "";
    } catch (e) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }
};

// 方法
const catext = (newlist) => {
  console.log(newlist, "看看是什么");
  if (Array.isArray(newlist)) {
    return newlist.map((item) => item.name).join(",");
  }
  return "";
};

const handleDialogClose = () => {
  editRow.value = null;
};

const handleUpdateSuccess = () => {
  showUpdate.value = false;
  pages.value.page = 1;
  noMore.value = false;
  list.value = [];
  getList();
};

const flList = async () => {
  try {
    const sendata = {};
    const res = await proxy.$api.System.ProductCategory.get(sendata);
    if (res.data.code == 200) {
      fenlei.value = res.data.data.list;
    } else {
      proxy.$message.error("获取类别列表失败");
      fenlei.value = [];
    }
  } catch (error) {
    console.error("获取类别列表异常：", error);
    proxy.$message.error("网络错误，获取类别列表失败");
    fenlei.value = [];
  }
};

// 查询：重置页码清空列表
const search = () => {
  pages.value.page = 1;
  noMore.value = false;
  list.value = [];
  getList();
};
// 加载下一页
const loadMore = async () => {
  await getList(true);
};

const up = (row) => {
  editRow.value = null;
  nextTick(() => {
    editRow.value = { ...row };
    showUpdate.value = true;
  });
};

const getList = async (isLoadMore = false) => {
  if (noMore.value || loading.value) return;
  const beginTime =
    dateRange.value && dateRange.value[0] ? dateRange.value[0] : "";
  const endTime =
    dateRange.value && dateRange.value[1] ? dateRange.value[1] : "";
  const sendata = {
    currentPage: pages.value.page,
    pageSize: pages.value.size,
    outerKey: username.value,
    flag: "",
    categoryId: fl.value,
    memberVersion: "",
    beginTime: beginTime,
    endTime: endTime,
  };
  try {
    loading.value = true;
    const res = await proxy.$api.Operation.UserProductlaunch.get(sendata);
    if (res.data.code == 200) {
      const currentData = Array.isArray(res.data.data.list)
        ? res.data.data.list
        : [];
      if (pages.value.page === 1) {
        list.value = currentData;
      } else {
        list.value = [...list.value, ...currentData];
      }
      const total = res.data.data.total;
      noMore.value =
        total != null
          ? list.value.length >= total
          : currentData.length < pages.value.size;
      pages.value.page += 1;
    } else if (!isLoadMore) {
      list.value = [];
      proxy.$message.error("获取列表失败：" + (res.data.msg || "未知错误"));
    }
  } catch (error) {
    console.error("获取列表异常：", error);
    if (!isLoadMore) list.value = [];
  } finally {
    loading.value = false;
  }
};

const delUser = async (id) => {
  try {
    const sendata = { id: id };
    const res = await proxy.$api.Operation.UserProductlaunch.del(sendata);
    if (res.data.code == 200) {
      proxy.$message.success("删除成功");
      pages.value.page = 1;
      noMore.value = false;
      list.value = [];
      getList();
    } else {
      proxy.$message.error("删除失败：" + (res.data.msg || "未知错误"));
    }
  } catch (error) {
    console.error("删除异常：", error);
    proxy.$message.error("网络错误，删除失败");
  }
};

onMounted(() => {
  flList();
  loadSearchCache();
  getList();
});
</script>

<style lang="scss" scoped>
@import "./product-list.scss";
:deep(.el-dialog) {
  margin-top: 0vh !important;
}
:deep(.el-dialog--center .el-dialog__body) {
  height: 880px;
}
.panel-title {
  color: #999;
}
/* 和其他页面统一的加载更多样式 */
.load-more {
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #666;
  cursor: pointer;
  &:hover {
    background: #e9ecef;
  }
  &.no-more {
    color: #999;
    cursor: default;
  }
}
</style>
